import VNFileTile from './VNFileTile';

interface Props {
  files: File[];
  onDelete: (e: Event, index: number) => void;
}

function VNFileList({ files, onDelete }: Props) {
  return (
    <div className="vn-file-list">
      {files.map((file, index) => {
        return (
          <div className="button-container" key={file.name}>
            <VNFileTile
              file={file}
              index={index}
              onDelete={(e) => {
                onDelete(e, index);
              }}
            />
          </div>
        );
      })}
    </div>
  );
}

export default VNFileList;
